
import { useOrdersApi } from '@widgets/orders'
import { useOnTimezoneChange } from '@entities/viewer'
import { resolveUrl } from '@shared/lib/url'
import { AppRoute } from '@shared/config'

/** The customer's Orders tab: the Orders page lifecycle, narrowed to one customer. */
export const useCustomerOrdersPage = (): void => {
  const route = useRoute()

  const pagePath = resolveUrl(AppRoute.CustomersOrders, { id: route.params.id as string })

  onMounted(() => {
    void useOrdersApi()
  })

  // Filters and pagination navigate by query; refetching keeps the table in sync with the URL.
  watch(() => route.query, () => {
    if (route.path === pagePath) void useOrdersApi()
  })

  // Timestamps arrive pre-shifted into the admin's view timezone, so a timezone change needs a refetch.
  useOnTimezoneChange(() => {
    void useOrdersApi()
  })
}
